"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.types = exports.yesNoType = exports.emailType = exports.phoneType = exports.addressType = exports.userType = exports.dateTimeType = exports.dateType = exports.numberType = exports.textType = void 0;
var textType = 'Text';
exports.textType = textType;
var numberType = 'Number';
exports.numberType = numberType;
var dateType = 'Date';
exports.dateType = dateType;
var dateTimeType = 'Datetime';
exports.dateTimeType = dateTimeType;
var userType = 'User';
exports.userType = userType;
var addressType = 'Address';
exports.addressType = addressType;
var phoneType = 'Phone';
exports.phoneType = phoneType;
var emailType = 'Email';
exports.emailType = emailType;
var yesNoType = 'YesNo';
exports.yesNoType = yesNoType;
var types = [textType, numberType, dateType, dateTimeType, userType, addressType, phoneType, emailType, yesNoType];
exports.types = types;
var _default = {
  textType: textType,
  numberType: numberType,
  dateType: dateType,
  dateTimeType: dateTimeType,
  userType: userType,
  addressType: addressType,
  phoneType: phoneType,
  emailType: emailType,
  yesNoType: yesNoType
};
exports["default"] = _default;